import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { AuthSessionService } from './auth-session.service';

// Guard for admin and customer protected routes.
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  // Inject session and router.
  constructor(private session: AuthSessionService, private router: Router) {}

  // Validate route access.
  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const roleCode = route.data['roleCode'];

    if (this.session.isLoggedIn() && (!roleCode || this.session.hasRole(roleCode))) {
      return true;
    }

    return roleCode === 'ADMIN'
      ? this.router.parseUrl('/admin/login')
      : this.router.parseUrl('/auth/customer-login');
  }
}
